import { ITableCol } from '@data/interfaces/itable.interface';

/**
 * Constantes para el módulo de Plantillas del sistema Dripping
 * Define columnas de tabla, acciones disponibles, variables y configuraciones
 */

// ============= OPCIONES DE ESTADO =============
export const TEMPLATE_STATUS_OPTIONS = [
  { value: 'true', label: 'Activa' },
  { value: 'false', label: 'Inactiva' }
];

export const TEMPLATE_STATUS_ENUM = {
  'true': 'Activa',
  'false': 'Inactiva'
};

export const TEMPLATE_STATUS_COLOR_ENUM = {
  'true': 'success',
  'false': 'danger'
};

// ============= COLUMNAS DE LA TABLA =============
export const TEMPLATE_COLUMNS: ITableCol[] = [
  { 
    type: 'text', 
    field: '_id', 
    header: 'ID', 
    showFilter: false, 
    dataType: 'link', 
    linkField: '_id', 
    rootLink: 'dripping/templates' 
  },
  { 
    type: 'text', 
    field: 'name', 
    header: 'Nombre', 
    showFilter: true 
  },
  { 
    type: 'text', 
    field: 'description', 
    header: 'Descripción', 
    showFilter: false 
  },
  { 
    type: 'enum', 
    field: 'activeStatus', 
    header: 'Estado', 
    showFilter: true, 
    dataType: 'enum', 
    enum: TEMPLATE_STATUS_ENUM, 
    enumColor: TEMPLATE_STATUS_COLOR_ENUM, 
    options: TEMPLATE_STATUS_OPTIONS 
  },
  { 
    type: 'text', 
    field: 'createdAt', 
    header: 'Fecha de Creación', 
    showFilter: false,
    dataType: 'date'
  }
];

// ============= ACCIONES DE LA TABLA =============
export const TEMPLATE_ACTIONS = [
  {
    title: 'Editar',
    icon: 'fa-solid fa-edit',
    action: 'EDIT',
    color: 'primary',
    permission: ['dripping', 'update'] as [string, string]
  },
  {
    title: 'Activar',
    icon: 'fa-solid fa-check-circle',
    action: 'ACTIVATE',
    color: 'success',
    permission: ['dripping', 'update'] as [string, string],
    rule: { field: 'active', value: false, type: 'equals' }
  },
  {
    title: 'Desactivar',
    icon: 'fa-solid fa-ban',
    action: 'DEACTIVATE',
    color: 'warning',
    permission: ['dripping', 'update'] as [string, string],
    rule: { field: 'active', value: true, type: 'equals' }
  },
  {
    title: 'Eliminar',
    icon: 'fa-solid fa-trash',
    action: 'DELETE',
    color: 'danger',
    permission: ['dripping', 'delete'] as [string, string]
  }
];

// ============= VARIABLES DISPONIBLES =============
/**
 * Interfaz para definir variables disponibles en plantillas
 */
export interface IVariableOption {
  key: string;          // Variable técnica: clientName
  label: string;        // Nombre amigable: "Nombre del cliente"
  example: string;      // Ejemplo: "Juan Pérez"
  category: 'cliente' | 'arrendamiento' | 'financiero' | 'empresa';
}

/**
 * Variables disponibles para usar en las plantillas
 * Se insertan con sintaxis {{variable}}
 */
export const AVAILABLE_VARIABLES: IVariableOption[] = [
  // Cliente
  { key: 'clientName', label: 'Nombre del cliente', example: 'Juan Pérez', category: 'cliente' },
  { key: 'clientEmail', label: 'Email del cliente', example: 'cliente@ejemplo.com', category: 'cliente' },
  { key: 'clientPhone', label: 'Teléfono del cliente', example: '555-1234-5678', category: 'cliente' },
  
  // Arrendamiento
  { key: 'leaseNumber', label: 'Número de arrendamiento', example: 'L-001234', category: 'arrendamiento' },
  
  // Financiero
  { key: 'amount', label: 'Monto a pagar', example: '$15,000.00', category: 'financiero' },
  { key: 'dueDate', label: 'Fecha de vencimiento', example: '31 de diciembre de 2025', category: 'financiero' },
  { key: 'daysOverdue', label: 'Días de mora', example: '5 días', category: 'financiero' },
  { key: 'totalDebt', label: 'Deuda total', example: '$8,500.00', category: 'financiero' },
  
  // Empresa
  { key: 'companyName', label: 'Nombre de la empresa', example: 'Rendafin', category: 'empresa' }
];

// ============= ICONOS DE CANALES =============
/**
 * Iconos FontAwesome para cada canal de comunicación
 */
export const CHANNEL_ICONS = {
  email: 'fa-solid fa-envelope',
  sms: 'fa-solid fa-message',
  whatsapp: 'fa-brands fa-whatsapp',
  call: 'fa-solid fa-phone'
};

/**
 * Colores para cada canal de comunicación
 */
export const CHANNEL_COLORS = {
  email: '#3b82f6', // blue
  sms: '#10b981', // green
  whatsapp: '#25D366', // whatsapp green
  call: '#8b5cf6' // purple
};

/**
 * Labels amigables para cada canal
 */
export const CHANNEL_LABELS = {
  email: 'Email',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
  call: 'Llamada'
};
